import { Button, IconButton } from '@ads/components-react';
import { XMark } from '@ads/icons';
import type { ReportExportStatus } from '@linka/domain/enums';
import { eventDashboardMutations } from '@linka/http/event-dashboard';
import { useTranslation } from '@linka/i18n';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { DialogClose, DialogContent, DialogDescription, DialogTitle } from '../../../../dialog/dialog';
import { useExportContext } from './context';

interface ExportSuccessDialogProps {
  status: ReportExportStatus;
  exportId: string;
}

export const ExportSuccessDialog = ({ status, exportId }: ExportSuccessDialogProps) => {
  const t = useTranslation();
  const { eventId, userEmail, assets } = useExportContext();
  const { mutate } = useMutation(eventDashboardMutations.downloadFile());

  useEffect(() => {
    mutate({ eventId, exportId });
  }, []);

  return (
    <DialogContent className='!max-w-[23rem] flex flex-col items-center justify-center gap-xxs relative'>
      <DialogClose asChild className='absolute top-nano right-nano'>
        <IconButton ariaLabel={t('export-flow.close')} hierarchy='tertiary' icon={XMark} />
      </DialogClose>
      <img src={assets?.success ?? '/svg/social.svg'} alt={t('export-flow.success')} className='size-[8.75rem]' />
      <div className='text-center space-y-micro'>
        <DialogTitle className='[&>button]:hidden justify-center ts-subtitle-sm text-ctx-content-title'>
          {t('export-flow.dialog.feedback.title')}
        </DialogTitle>
        <DialogDescription className='text-ctx-content-base ts-paragraph-xxs line-clamp-none'>
          {status === 'READY_FOR_DOWNLOAD'
            ? t('export-flow.dialog.feedback.description')
            : t('export-flow.dialog.feedback.email', { email: userEmail ?? '' })}
        </DialogDescription>
        <DialogClose asChild>
          <Button size='md'>{t('export-flow.close')}</Button>
        </DialogClose>
      </div>
    </DialogContent>
  );
};
